import { type Camera, Vector3 } from 'three/webgpu';

const _cam = new Vector3();

/**
 * Where render-space point `p` lands on screen, for HTML overlays: `out` gets its normalized
 * device x and y (−1 to 1 across the view), and the result says whether it's in front of the
 * camera at all. Tested in camera space, not by the projected z: with the reversed-Z projection
 * a point behind the camera still projects to a z in range, mirrored through the middle of the
 * view (health bars showed up behind you). Needs the camera's world matrices up to date.
 */
export function toScreen(p: Vector3, camera: Camera, out: Vector3): boolean {
  _cam.copy(p).applyMatrix4(camera.matrixWorldInverse);
  // The camera looks down its −Z.
  if (_cam.z > -1e-4) return false;
  out.copy(p).project(camera);
  return true;
}
